export const DATABOX_CONNECT_FORM_ID = 'databox-connect-form';
